/* OrderItemReviewButton — "Beri Ulasan" / "Edit Ulasan" per item pesanan selesai. */
import React, { useCallback, useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "@/lib/api";
import { useIsFeatureEnabled } from "@/hooks/useFeatureFlag";
import ReviewForm from "@/components/ReviewForm";

export default function OrderItemReviewButton({ orderId, itemIndex, item }) {
  const enabled = useIsFeatureEnabled("reviews.product");
  const [elig, setElig] = useState(null);
  const [open, setOpen] = useState(false);
  const orderItemId = `${orderId}:${itemIndex}`;

  const load = useCallback(() => {
    api.get("/reviews/eligibility", { params: { order_id: orderId } })
      .then((r) => setElig(r.data.items.find((x) => x.order_item_id === orderItemId) || null))
      .catch(() => setElig(null));
  }, [orderId, orderItemId]);

  useEffect(() => { if (enabled) load(); }, [enabled, load]);
  if (!enabled || !elig || (!elig.eligible && !elig.review)) return null;

  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        className="mt-1 inline-flex items-center gap-1 text-xs font-semibold text-[color:var(--brand-primary)] underline"
        data-testid={`order-item-review-${itemIndex}`}>
        <Star size={12} /> {elig.review ? "Lihat / Edit Ulasan" : "Beri Ulasan"}
      </button>
      {open && (
        <ReviewForm key={elig.review?.id || "new"} open={open} onOpenChange={setOpen} orderId={orderId}
          item={{ ...item, order_item_id: orderItemId }} existing={elig.review} onSaved={load} />
      )}
    </>
  );
}
